import styled, { keyframes, css } from 'styled-components';
import { zIndex } from '../global/globals';
import { fadeIn } from '../base/keyframes/fades';
import media from '../base/media';

const menuOpen = keyframes`
	0% { opacity: 0; transform: translate3d(0, 10px, 0); }
	100% { opacity: 1; transform: translate3d(0, 0, 0); }
`;

export const Overlay = styled.div`
	position: fixed;
	top: 0; right: 0;
	width: 100%;
	height: 100%;
	background: rgba(255,255,255, 0.5);
	z-index: ${zIndex.contextMenuOverlay};
	animation: ${fadeIn} 200ms;
	transition: opacity 250ms ease;

	${({ closing }) => closing && css`
		opacity: 0;
		pointer-events: none;
	`}
`;

export const Wrapper = styled.div`
	position: absolute;
	top: ${({ y }) => y - 40}px;
	left: ${({ x }) => x}px;
	z-index: ${zIndex.modals};
	animation: ${menuOpen} 200ms ease forwards;
	border-radius: 4px;
	transition: opacity 250ms ease;
	${media.desktopSmall`
		top: ${({ y }) => y}px;
	`}

	${({ closing }) => closing && css`
		animation-fill-mode: backwards;
		opacity: 0;
		pointer-events: none;
	`}
`;
